// 페이징 UI: 페이지 번호 버튼을 10개 단위로만 노출 (1~10, 11~20, 21~30 …)
const PAGES_PER_GROUP = 10;

customElements.define('custom-point', class extends HTMLElement {
  submitData = {};
  constructor() {
    super();
    this.customer = JSON.parse(this.getAttribute("data-customer") || "{}");
    this.customerInfo = {};

    this.currentPage = 1;
    this.totalPages = 0;

    this.handleGetPointHistory()
    this.handleGetPointSummary()
  }

  getPageRange() {
    const start = Math.floor((this.currentPage - 1) / PAGES_PER_GROUP) * PAGES_PER_GROUP + 1;
    const end = Math.min(start + PAGES_PER_GROUP - 1, this.totalPages);
    return { start, end };
  }

  renderPageLinks() {
    const pagination = this.querySelector('.pagination');
    if (!pagination) return;
    const existingLinks = this.querySelectorAll('.page-link');
    existingLinks.forEach(el => el.remove());

    const { start, end } = this.getPageRange();
    const insertBeforeEl = this.querySelector('#nextGroup');

    for (let i = start; i <= end; i++) {
      const a = document.createElement('a');
      a.classList.add('page-link');
      if (i === this.currentPage) a.classList.add('active');
      a.setAttribute('data-page', String(i));
      a.setAttribute('href', '#');
      a.textContent = String(i);
      pagination.insertBefore(a, insertBeforeEl);
    }

    const prevGroup = this.querySelector('#prevGroup');
    const nextGroup = this.querySelector('#nextGroup');
    if (prevGroup) prevGroup.classList.toggle('disabled', start <= 1);
    if (nextGroup) nextGroup.classList.toggle('disabled', end >= this.totalPages);
  }

  async handleGetPointSummary() {
    const url = window.middlewareUrls.pointSummary;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          shopId: this.customer.shopId,
          cstmIntgSeq: this.customer.cstmIntgSeq,
        })
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const resJson = await response.json();

      const pointValue = this.querySelector('.custom-points__value');
      pointValue.innerHTML = new Intl.NumberFormat().format(resJson.data.availablePoint) + "P";
      return resJson;
    } catch (error) {
      console.error(error.message);
    }
  }

  async handleGetPointHistory() {
    const url = window.middlewareUrls.pointList;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shopId: this.customer.shopId,
          cstmIntgSeq: this.customer.cstmIntgSeq,
          page: "1",
        })
      });
      if (!response.ok) throw new Error(`Response status: ${response.status}`);
      const resJson = await response.json();
      const pointData = resJson?.data?.point_data ?? null;

      if (pointData && pointData.length) {
        this.totalPages = (pointData[0] && pointData[0].totPage != null) ? pointData[0].totPage : 1;
        let tableData;
        let pagination;

        pointData.forEach((point) => {
          const date = this.formatDate(point?.date);
          const validPeriod = this.formatDate(point?.validPeriod);
          const formatPoint = new Intl.NumberFormat().format(point?.point);

          tableData = document.createElement('li');
          tableData.classList.add('mypage-list__item', 'table-data');
          tableData.innerHTML = `
            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Title</dt>
              <dd class="mypage-list__value">${point?.typeNM || ""}</dd>
            </dl>
  
            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Points</dt>
              <dd class="mypage-list__value">
                <span class="custom-points__value-point">${formatPoint || ""}P</span>
              </dd>
            </dl>
  
            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Date Earned</dt>
              <dd class="mypage-list__value">${date || ""}</dd>
            </dl>
  
            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Expiration Date</dt>
              <dd class="mypage-list__value">${validPeriod || ""}</dd>
            </dl>
          `;
          this.querySelector('.mypage-list').appendChild(tableData);
        })

        pagination = document.createElement('div');
        pagination.classList.add('pagination');
        pagination.innerHTML = `
          <a href="#points-history" id="prev" class="disabled">&lt;</a>
          <a href="#points-history" id="prevGroup" class="pagination-group disabled" aria-label="Previous page group">&laquo;</a>
          <a href="#points-history" id="next" class="disabled">&gt;</a>
          <a href="#points-history" id="nextGroup" class="pagination-group disabled" aria-label="Next page group">&raquo;</a>
        `;
        const nextBtn = pagination.querySelector('#next');
        const nextGroupBtn = pagination.querySelector('#nextGroup');
        if (nextGroupBtn) nextGroupBtn.remove();
        if (nextBtn) nextBtn.remove();
        this.appendChild(pagination);
        if (nextGroupBtn) pagination.appendChild(nextGroupBtn);
        if (nextBtn) pagination.appendChild(nextBtn);

        if (this.totalPages > 1) {
          this.renderPageLinks();

          this.querySelector('#next').classList.remove('disabled');

          const paginationEl = this.querySelector('.pagination');
          if (!paginationEl.dataset.delegationAdded) {
            paginationEl.dataset.delegationAdded = 'true';
            paginationEl.addEventListener('click', (e) => {
              const link = e.target.closest('.page-link');
              if (!link) return;
              e.preventDefault();
              const page = parseInt(link.getAttribute('data-page'), 10);
              if (page && page !== this.currentPage && page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
                this.updatePagination();
              }
            });
          }

          const prevButton = this.querySelector('#prev');
          const nextButton = this.querySelector('#next');
          const prevGroupBtn = this.querySelector('#prevGroup');
          const nextGroupBtn = this.querySelector('#nextGroup');

          prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (!prevButton.classList.contains('disabled') && this.currentPage > 1) {
              this.currentPage--;
              this.updatePagination();
            }
          });

          nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (!nextButton.classList.contains('disabled') && this.currentPage < this.totalPages) {
              this.currentPage++;
              this.updatePagination();
            }
          });

          prevGroupBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if (prevGroupBtn.classList.contains('disabled')) return;
            const { start } = this.getPageRange();
            if (start > 1) {
              this.currentPage = start - 1;
              this.updatePagination();
            }
          });

          nextGroupBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if (nextGroupBtn.classList.contains('disabled')) return;
            const { end } = this.getPageRange();
            if (end < this.totalPages) {
              this.currentPage = end + 1;
              this.updatePagination();
            }
          });
        } else {
          const page = document.createElement('a');
          page.classList.add('page-link', 'active');
          page.setAttribute('data-page', '1');
          page.setAttribute('href', '#');
          page.textContent = '1';
          pagination.insertBefore(page, this.querySelector('#nextGroup'));
        }
      } else {
        const pointsHistory = this.querySelector('#points-history');
        if (pointsHistory) {
          let pagination = this.querySelector('.pagination');
          if (!pagination) {
            pagination = document.createElement('div');
            pagination.className = 'pagination';
            pointsHistory.after(pagination);
          }
        }
      }
    } catch (error) {
      console.error('[custom-point]', error.message);
    }
  }

  formatDate(date) {
    const formatDate = new Date(date);
    let day = formatDate.getDate();
    let month = formatDate.getMonth() + 1;
    const year = formatDate.getFullYear();

    if (day < 10) {
      day = '0' + day;
    }

    if (month < 10) {
      month = '0' + month;
    }

    return [year, month, day].join('.');
  }

  async updatePagination() {
    const url = window.middlewareUrls.pointList;
    const prevButton = this.querySelector('#prev');
    const nextButton = this.querySelector('#next');

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shopId: this.customer.shopId,
          cstmIntgSeq: this.customer.cstmIntgSeq,
          page: this.currentPage.toString(),
        })
      });
      if (!response.ok) throw new Error(`Response status: ${response.status}`);
      const resJson = await response.json();
      const pointData = resJson?.data?.point_data ?? null;

      prevButton.classList.toggle('disabled', this.totalPages <= 1 || (this.totalPages > 1 && this.currentPage === 1));
      nextButton.classList.toggle('disabled', this.totalPages <= 1 || (this.totalPages > 1 && this.currentPage === this.totalPages));

      this.renderPageLinks();

      const tableData = this.querySelectorAll('.table-data');
      tableData.forEach(e => e.remove());

      if (pointData && pointData.length) {
        let newNode;

        pointData.forEach((point) => {
          const date = this.formatDate(point?.date);
          const validPeriod = this.formatDate(point?.validPeriod);
          const formatPoint = new Intl.NumberFormat().format(point?.point);

          newNode = document.createElement('li');
          newNode.classList.add('mypage-list__item', 'table-data');
          newNode.innerHTML = `
            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Title</dt>
              <dd class="mypage-list__value">${point?.typeNM || ""}</dd>
            </dl>

            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Points</dt>
              <dd class="mypage-list__value">
                <span class="custom-points__value-point">${formatPoint || ""}P</span>
              </dd>
            </dl>

            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Date Earned</dt>
              <dd class="mypage-list__value">${date || ""}</dd>
            </dl>

            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Expiration Date</dt>
              <dd class="mypage-list__value">${validPeriod || ""}</dd>
            </dl>
          `;
          this.querySelector('.mypage-list').appendChild(newNode);
        })
      }
    } catch (error) {
      console.error(error.message);
    }
  }
})